import {
    createContext,
    useCallback,
    useContext,
    useMemo,
    useState,
} from 'react'
import { createPortal } from 'react-dom'

const MarketXToolbarContext = createContext(null)

export function MarketXToolbarProvider({ children }) {
    const [slotEl, setSlotElState] = useState(null)

    const setSlotEl = useCallback((el) => {
        setSlotElState((prev) => (prev === el ? prev : el))
    }, [])

    const value = useMemo(
        () => ({
            slotEl,
            setSlotEl,
        }),
        [slotEl, setSlotEl]
    )

    return (
        <MarketXToolbarContext.Provider value={value}>
            {children}
        </MarketXToolbarContext.Provider>
    )
}

export function useMarketXToolbarSlot() {
    return useContext(MarketXToolbarContext)
}

/** Renders page controls into the MarketX header toolbar slot. */
export function MarketXToolbar({ children }) {
    const ctx = useMarketXToolbarSlot()
    if (!ctx?.slotEl) return null
    return createPortal(children, ctx.slotEl)
}
